
export function countDuplicate(array: string[], element: any) {
  let i = 0;
  let count = 0;

  while (i < array.length) {
    if (array[i] == element) count++;

    i++;
  }

  return count;
}


export const BackdatedReasons = {
  "spouse": {
    "ADD_SPOUSE_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "REMOVE_SPOUSE_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "MARRIED_30_BEFORE_NOT_COVERED": "Marriage occurred over 30 days ago, and the spouse is not covered.",
    "COMMONLAW_365_BEFORE_NOT_COVERED": "Living together for more than a year, but the spouse is not covered."
  },
  "children": {
    "ADD_CHILDREN_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "REMOVE_CHILDREN_EFFECTIVE_BACKDATED": "Plan need to be effective retroactively.",
    "CHILDREN_WITH_DISABLITY": "The child has a disability.",
    "CHILDREN_ABOVE_18_NO_STUDENT_NOT_COVERED": "The child is over 18, not a student, and not covered.",
    "CHILDREN_ABOVE_18_STUDENT_NOT_COVERED": "The child is over 18, a student, but not covered."
  } 
}

// export function invoiceFilter(customerInvoices,customerNewInvoices) {
//   const endOfMay2024 = new Date('2024-05-31T23:59:59');

//   let filteredInvoices = customerInvoices.filter(invoice => {
//     const invoiceDueDate = new Date(invoice.dueDate);

//     console.log(invoiceDueDate, invoiceDueDate <= endOfMay2024)
//     return invoiceDueDate <= endOfMay2024;
//   });
//   return filteredInvoices
// }
function checkCategory(date) {
  if (date >= 1 && date <= 14) {
    return "first_quarter"
  }
  else {
    return "second_quarter"
  }
}



export function checkValidObject(object:any){
  let objKeys = Object.keys(object);
  if(objKeys.length > 0){
    return true
  }else{
    return false
  }
}

export function invoiceFilter(customerInvoices, customerNewInvoices) {
  let filteredInvoices = []
  customerInvoices.forEach(invoice => {
    let inv;
    for (let i of customerNewInvoices) {
      const olddate = new Date(invoice.dueDate).getDate()
      const newdate = new Date(i.dueDate).getDate()
      //  console.log(olddate,newdate,checkCategory(olddate),checkCategory(newdate))
      const sameSet = checkCategory(olddate) === checkCategory(newdate)

      console.log(new Date(invoice.dueDate), new Date(invoice.dueDate).getMonth(), new Date(i.dueDate).getMonth(), sameSet, new Date(invoice.dueDate).getFullYear() === new Date(i.dueDate).getFullYear())
      if (new Date(invoice.dueDate).getMonth() === new Date(i.dueDate).getMonth() && new Date(invoice.dueDate).getFullYear() === new Date(i.dueDate).getFullYear() && sameSet) {
        inv = i;
        break;
      }
    }
    if (inv) {
      filteredInvoices.push(inv)

    }
    else {
      filteredInvoices.push(invoice)

    }
  });
  filteredInvoices = [...filteredInvoices, ...customerNewInvoices]
  const unique = filteredInvoices.filter((obj, index) => {
    return index === filteredInvoices.findIndex(o => new Date(obj.dueDate).getTime() === new Date(o.dueDate).getTime());
  });

  // console.log(unique)


  return unique

}


export function objectLength(obj: any) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
}

export function onlyUnique(value: any, index: number, self: any) {
  return self.indexOf(value) === index;
}

export async function intersection(a: any, b: any) {
  var t;
  if (b.length > a.length) (t = b), (b = a), (a = t); // indexOf to loop over shorter
  return a
    .filter(function (e: any) {
      return b.indexOf(e) > -1;
    })
    .filter(function (e: any, i: any, c: any) {
      // extra step to remove duplicates
      return c.indexOf(e) === i;
    });
}

export async function randomString(length: number, chars: string) {
  var result = '';
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}



export async function generateRandomPassword() {
  return await randomString(
    8,
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  );
}

export function getRandomIdBetween(min: number, max: number) {
  return parseInt((Math.random() * (max - min) + min).toString());
}

export function floatWith2Decimalsfn(amount: number) {
  return parseFloat(Number(amount).toFixed(2));
}

export const btoa = function (str: string) {
  // return Buffer.from(str).toString('base64');
};
export const atob = function (b64Encoded: string) {
  // return Buffer.from(b64Encoded, 'base64').toString();
};

export const floatWith2Decimals = (amount: number) =>
  parseFloat(amount.toFixed(2));

export const sumBy = (items: Array<any>, prop: string) =>
  items.reduce((a, b) => +a + +parseFloat(b[prop]), 0);

export const sumByV2 = (items: Array<any>, prop1: string, prop2: string) =>
  items.reduce((a, b) => +a + (b[prop1].reduce((c: any, d: any) => +c + +parseFloat(d[prop2]), 0)), 0)

export const adjustWith2DecimalsForUI = (amount: number | string) =>
  +parseFloat(amount.toString()).toFixed(2);

export function groupBy(xs, prop) {
  var grouped = {};
  for (var i = 0; i < xs.length; i++) {
    var p = xs[i][prop];
    if (!grouped[p]) { grouped[p] = []; }
    grouped[p].push(xs[i]);
  }
  return grouped;
}



export function mailSuggestedTextForProviders(service:any, eventType:any, effectiveDate:any) {
  let data:any = '';


  if(service.greenShildCustomer){
      data = `Hi GreenShield Team,\n`
      data +=  `Please ${eventType} the following customer into the Greenshield site with effective date from ${effectiveDate}`
  }
  else if(service.equitableCustomer){
    data = `Hi Equitable Team,\n`
    data +=  `Please ${eventType} the following customer into the Equitable site with effective date from ${effectiveDate}`
  }
  else {
     data = `Hi Team,\n`
    data +=  `Please ${eventType} the following customer into the site with effective date from ${effectiveDate}`
  }

  return data;
}

export function getServiceType(services:any) {
  let currentServices = 'NA'
  Object.keys(services).map((i) => {
    if(services[i]){
      if(i == 'greenShildCustomer'){
        currentServices='Greenshield'
      }
      else if(i == 'equitableCustomer'){
        currentServices='Equitable'
      }
    }
  })

  return currentServices;
}

export function getFooterTextForEmail() {
  let data = `Best Regards,`
  data += '\n'
  data += 'Group Benefitz.'

  return data
}

 export function handleAmountonUI(amount:any){
    amount = parseFloat(amount);
    const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formatted;
  }